import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Sanitize a user-supplied URL before rendering it into an href / window.open.
 * Blocks javascript:, data:, vbscript:, file:, and any other non-http(s) scheme
 * so a malicious listing/submission can't execute script in a viewer's session.
 * Returns "#" (safe no-op) for anything that isn't a plain http(s) link.
 * Empty / null input returns "" so consumers can conditionally render.
 */
export function safeUrl(url) {
  if (url == null) return "";
  const s = String(url).trim();
  if (!s) return "";
  // Reject any embedded control chars
  if (/[\r\n\t]/.test(s)) return "#";
  const low = s.toLowerCase();
  if (low.startsWith("http://") || low.startsWith("https://")) return s;
  if (low.startsWith("//")) return "https:" + s;
  if (
    low.startsWith("javascript:") ||
    low.startsWith("data:") ||
    low.startsWith("vbscript:") ||
    low.startsWith("file:")
  ) {
    return "#";
  }
  // Bare `example.com/...` → default to https
  if (!s.includes("://") && /^[a-z0-9.-]+\.[a-z]{2,}(?:[/?#].*)?$/i.test(s)) {
    return "https://" + s;
  }
  return "#";
}
